import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
import { postData } from "../api/client";
import endpoints from "../api/endpoints";
import { useSiteLogo } from "../api/siteLogo";

function Register() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const logo = useSiteLogo();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (!firstName || !lastName || !email || !password) {
      setError("Please fill in all fields");
      return;
    }

    setLoading(true);

    try {
      const data = await postData(endpoints.REGISTER, {
        firstName,
        lastName,
        email,
        password,
      });
      setMessage(data?.message || "Registered successfully");
      setFirstName("");
      setLastName("");
      setEmail("");
      setPassword("");
      setTimeout(() => {
        navigate("/login");
      }, 1200);
    } catch (err) {
      setError(err?.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />

      <Breadcrumb title="Register" path="Register" />

      <div className="auth-area py-120">
        <div className="container">
          <div className="col-md-5 mx-auto">
            <div className="auth-form">
              <div className="auth-header">
                <img src={logo} alt="Kademy Logo" />
                <p>Create your free Kademy account</p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <div className="form-icon">
                    <i className="far fa-user-tie"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="First name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="form-icon">
                    <i className="far fa-user-tie"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last name"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="form-icon">
                    <i className="far fa-envelope"></i>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="form-icon">
                    <i className="far fa-key"></i>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="auth-group">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="agree"
                      required
                    />
                    <label className="form-check-label" htmlFor="agree">
                      I agree with the{" "}
                      <Link to="/terms" className="auth-group-link">
                        Terms Of Service.
                      </Link>
                    </label>
                  </div>
                </div>

                {message && (
                  <p
                    className="text-success"
                    style={{ marginBottom: 8, textAlign: "center" }}
                  >
                    {message}
                  </p>
                )}
                {error && (
                  <p
                    className="text-danger"
                    style={{ marginBottom: 8, textAlign: "center" }}
                  >
                    {error}
                  </p>
                )}

                <div className="auth-btn">
                  <button
                    type="submit"
                    className="theme-btn"
                    disabled={loading}
                  >
                    <span className="far fa-paper-plane"></span>
                    {loading ? " Registering..." : " Register"}
                  </button>
                </div>
              </form>
              <div style={{ textAlign: "center", marginTop: 16 }}>
                <p className="auth-bottom-text" style={{ margin: 0 }}>
                <div className="auth-social" style={{ marginTop: 20 }}>
              <p style={{ textAlign: "center" }}>Continue with Google</p>
              <div className="auth-social-list" style={{ textAlign: "center" }}>
                <a
                  href="https://google.com"
                  target="_blank"
                  rel="noreferrer"
                  style={{ fontSize: 22 }}
                >
                  <i className="fab fa-google"></i>
                </a>
              </div>
            </div>
                 <span>Already have an account?</span>
                  <Link to="/login" style={{ marginLeft: 8 }}>Login.</Link>
                </p>
              </div>
              </div>
            </div>
            
          </div>
        </div>
      <Footer />
    </>
  );
}

export default Register;
